module.exports = __webpack_public_path__ + "media/images/ibu__social__logo__twitter-443a24867534926f30c072a46926d8db.svg";